import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { FileSystemsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.FileSystem };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    FileSystemsActions.CreateFileSystem,
    FileSystemsActions.ReadFileSystem,
    FileSystemsActions.ReadFileSystems,
    FileSystemsActions.UpdateFileSystem,
    FileSystemsActions.DeleteFileSystem,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(FileSystemsActions.ReadFileSystemSuccess, (state, { response }) => {
    const entities = {
      ...state.entities,
      [response['@id']]: response
    };

    return {
      ...state,
      entities,
      loading: false,
      loaded: false
    };
  }),
  on(FileSystemsActions.ReadFileSystemsSuccess, (state, { response }) => {
    const items = response['hydra:member'];
    const entities = items.reduce(
      (entities: { [iri: string]: fromModuleModels.FileSystem }, item) => {
        return {
          ...entities,
          [item['@id']]: item
        };
      },
      { ...state.entities }
    );

    return {
      ...state,
      entities,
      loading: false,
      loaded: true
    };
  }),
  on(
    FileSystemsActions.CreateFileSystemSuccess,
    FileSystemsActions.UpdateFileSystemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(FileSystemsActions.DeleteFileSystemSuccess, (state, { iri }) => {
    const { [iri]: removedItem, ...entities }: any = state.entities;

    return {
      ...state,
      entities,
      loading: false,
      loaded: true
    };
  }),
  on(
    FileSystemsActions.CreateFileSystemFail,
    FileSystemsActions.ReadFileSystemFail,
    FileSystemsActions.ReadFileSystemsFail,
    FileSystemsActions.UpdateFileSystemFail,
    FileSystemsActions.DeleteFileSystemFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
